<app-deprecated-confirmation-dialog #confirmDeleteDialog [label]="'Delete'"></app-deprecated-confirmation-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-steps
        #appSteps
        [labels]="{ primary: 'save' }"
        action="click"
        [steps]="[basicStep, uploadStep, reviewStep]"
        (onNext)="onNextStep($event)"
        (onPrimary)="onSave()"
    >
        <app-step
            #basicStep
            [stepForm]="basicForm"
            step="applicant-tracker.applicants.create.newApplicant"
            title="applicant-tracker.applicants.create.applicantInformation"
        >
            <app-applicant-store-basic-information
                #basicForm
                [applicant]="applicant"
            ></app-applicant-store-basic-information>
        </app-step>

        <app-step
            #uploadStep
            [stepForm]="uploadForm"
            step="applicant-tracker.applicants.create.uploadDocument"
            title="applicant-tracker.applicants.create.uploadDocument"
        >
            <app-applicant-store-upload-form [applicant]="applicant" #uploadForm></app-applicant-store-upload-form>
        </app-step>

        <app-step
            #reviewStep
            [stepForm]="reviewForm"
            step="applicant-tracker.applicants.create.summary"
            title="applicant-tracker.applicants.create.summary"
        >
            <app-applicant-store-review-information
                #reviewForm
                [applicant]="applicant"
            ></app-applicant-store-review-information>
        </app-step>
    </app-steps>
</div>
